import { render, staticRenderFns } from "./recebimento.vue?vue&type=template&id=6df88340&scoped=true"
import script from "./recebimento.vue?vue&type=script&lang=ts"
export * from "./recebimento.vue?vue&type=script&lang=ts"
import style0 from "./recebimento.vue?vue&type=style&index=0&id=6df88340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df88340",
  null
  
)

export default component.exports